import { useDispatch } from 'react-redux';
import type { Action, AnyAction } from '@reduxjs/toolkit';

export function useDeferredDispatch() {
    const dispatch = useDispatch();
    return <T, A extends Action = AnyAction>(action: A) => {
        return dispatch(action) as unknown as Promise<T>;
    };
}
